import { useEffect, useRef } from "react";
import { ENV, POSTHOG_HOST, POSTHOG_KEY } from "@constants/constants";
import posthog from "posthog-js";
import { Router, useRouter } from "next/router";

const usePostHogCustom = () => {
  const router = useRouter();
  const oldUrlRef = useRef("");
  const allowedRoutes = [
    "signature/deals",
    "signature/pricing",
    "signature/gsuite-addon",
  ];
  const isSubPath = (path, subPath) => {
    return path?.includes(subPath || "") ?? false;
  };

  useEffect(() => {
    // Return early if in development environment
    if (ENV === "DEV") {
      return;
    }

    // Only run the following code in production
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST || "https://us.i.posthog.com",
      loaded: (posthog) => {
        if (ENV === "DEV") posthog.debug();
      },
    });

    const handleRouteChange = () => posthog?.capture("$pageview");
    const handleRouteChangeStart = () =>
      posthog?.capture("$pageleave", {
        $current_url: oldUrlRef.current,
      });

    Router.events.on("routeChangeComplete", handleRouteChange);
    Router.events.on("routeChangeStart", handleRouteChangeStart);
    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
      Router.events.off("routeChangeStart", handleRouteChangeStart);
    };
  }, []);

  useEffect(() => {
    const isPathAllowed = allowedRoutes.some((route) =>
      isSubPath(router.pathname, route)
    );
    if (!isPathAllowed) {
      posthog.opt_out_capturing();
      return;
    } else {
      posthog.opt_in_capturing();
    }
  }, [router.pathname]);
};

export default usePostHogCustom;
